import { environment } from '../../environments/environment';
import type { CompanySearchApiResult } from './fetchCompanySearchResults';

export const fetchCompanySubsidiaries = async (
  rcid: number,
  signal?: AbortSignal
): Promise<CompanySearchApiResult[]> => {
  const response = await fetch(
    `${environment.COMPANY_MAPPER_URL}/subsidiaries`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ rcid }),
      signal,
    }
  );

  if (!response.ok) {
    throw new Error(`subsidiaries failed: ${response.status}`);
  }

  return response.json();
};
